/**
 * 判断从server端拿到的response是否有效
 * @param {*} obj
 */
export function isValidResponse (obj) {
    return obj !== undefined && obj !== null
  }